<template lang="pug" src="./appointment-form.pug"></template>

<script>
import api from 'api'
import axios from 'axios'

export default {
  props: ['props'],
  data () {
    return {
      error: false,
      dropdown: false,
      firstvisit: '',
      name_Visit: '',
      birthdate_Visit: '',
      name_Patient: '',
      greeting_Patient: '',
      street_Patient: '',
      city_Patient: '',
      state_Patient: '',
      zip_Patient: '',
      birthdate_Patient: '',
      gender: '',
      IdentifiesAs_Patient: '',
      email_Patient: '',
      cellphone_Patient: '',
      momDad_Patient: '',
      homephone_Patient: '',
      email2_Patient: '',
      Doctor_Referrals: '',
      Dentist_Referrals: '',
      name_Billing: '',
      relation: '',
      greeting_Billing: '',
      street_Billing: '',
      city_Billing: '',
      state_Billing: '',
      zip_Billing: '',
      email_Billing: '',
      cellphone_Billing: '',
      office: '',
      birthdate_Billing: '',
      security_Billing: '',
      dentist_Billing: '',
      hear_Billing: '',
      postUrl: api + '/rg-mail/v1/contact',
      formSubmitted: false,
      formSuccess: false,
      modalShowing: false
    }
  },
  methods: {
    location () {
      this.dropdown ? this.dropdown = false : this.dropdown = true
    },
    setLocation (l) {
      this.office = l
      this.dropdown ? this.dropdown = false : this.dropdown = true
    },
    validate () {
      if (this.office === 'Choose a Location') {
        this.error = true
      }
      this.$validator.validateAll()
        .then(result => {
          if (result) {
            this.onSubmit()
          }
        })
        .catch((e) => {
          console.log(e)
        })
    },
    onSubmit () {
      this.formSubmitted = true
      axios.post(this.postUrl, {
        firstvisit: this.firstvisit,
        name_Visit: this.name_Visit,
        birthdate_Visit: this.birthdate_Visit,
        name_Patient: this.name_Patient,
        greeting_Patient: this.greeting_Patient,
        street_Patient: this.street_Patient,
        city_Patient: this.city_Patient,
        state_Patient: this.state_Patient,
        zip_Patient: this.zip_Patient,
        birthdate_Patient: this.birthdate_Patient,
        gender: this.gender,
        IdentifiesAs_Patient: this.IdentifiesAs_Patient,
        email_Patient: this.email_Patient,
        cellphone_Patient: this.cellphone_Patient,
        momDad_Patient: this.momDad_Patient,
        homephone_Patient: this.homephone_Patient,
        email2_Patient: this.email2_Patient,
        Doctor_Referrals: this.Doctor_Referrals,
        Dentist_Referrals: this.Dentist_Referrals,
        name_Billing: this.name_Billing,
        relation: this.relation,
        greeting_Billing: this.greeting_Billing,
        street_Billing: this.street_Billing,
        city_Billing: this.city_Billing,
        state_Billing: this.state_Billing,
        zip_Billing: this.zip_Billing,
        email_Billing: this.email_Billing,
        cellphone_Billing: this.cellphone_Billing,
        office: this.office,
        birthdate_Billing: this.birthdate_Billing,
        security_Billing: this.security_Billing,
        dentist_Billing: this.dentist_Billing,
        hear_Billing: this.hear_Billing
      })
        .then(res => {
          this.formSuccess = true
          setTimeout(() => {
            window.location.href = 'https://www.baker-ortho.com/thank-you'
          }, 400)
          setTimeout(() => {
            this.firstvisit = ''
            this.name_Visit = ''
            this.birthdate_Visit = ''
            this.name_Patient = ''
            this.greeting_Patient = ''
            this.street_Patient = ''
            this.city_Patient = ''
            this.state_Patient = ''
            this.zip_Patient = ''
            this.birthdate_Patient = ''
            this.gender = ''
            this.IdentifiesAs_Patient = ''
            this.email_Patient = ''
            this.cellphone_Patient = ''
            this.momDad_Patient = ''
            this.homephone_Patient = ''
            this.email2_Patient = ''
            this.Doctor_Referrals = ''
            this.Dentist_Referrals = ''
            this.name_Billing = ''
            this.relation = ''
            this.greeting_Billing = ''
            this.street_Billing = ''
            this.city_Billing = ''
            this.state_Billing = ''
            this.zip_Billing = ''
            this.email_Billing = ''
            this.cellphone_Billing = ''
            this.office = 'Choose a Location'
            this.birthdate_Billing = ''
            this.security_Billing = ''
            this.dentist_Billing = ''
            this.hear_Billing = ''
          }, 1000)
          setTimeout(() => {
            this.errors.clear()
          }, 1100)
        })
        .catch(e => {
          console.log(e, 'submitted')
        })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/forms/appointment-form/appointment-form.vue